import type { AdaptiveLogger } from "@1js/office-online-jsapi-core";
import type {
  AccessTokenFunction,
  OwletEventHandlers,
  SessionConfig,
  UiHostConfig,
  EventHandlers,
  DocumentBootInfo,
} from "../types";
import { rebootDocumentHandler } from "./eventHandlers/rebootDocumentHandler";
import { pageLoadedHandler } from "./eventHandlers/pageLoadedHandler";
import type { IWACPageLoadResult } from "../messages/messageTypes/Notification";
import type { Health } from "@1js/office-online-qos-small";

export function createAndAppendOwletEventHandlers(
  documentBootInfo: DocumentBootInfo,
  sessionConfig: SessionConfig,
  uiHostConfig: UiHostConfig,
  getAuthToken: AccessTokenFunction,
  container: HTMLElement,
  uiHostEventHandlers: EventHandlers,
  hostingPageOrigin: string,
  logger?: AdaptiveLogger,
  health?: Health,
  sessionId?: string
): OwletEventHandlers {
  const onRebootDocumentHandler = async (
    newDocBootUrl: string,
    eventHandlers: OwletEventHandlers,
    rebootReason?: string,
    rebootMode?: string
  ) => {
    await rebootDocumentHandler({
      documentBootInfo,
      sessionConfig,
      uiHostConfig,
      getAuthToken,
      container,
      eventHandlers,
      hostingPageOrigin,
      logger,
      newDocBootUrl,
      rebootReason,
      rebootMode,
    });
  };

  const onPageLoadedHandler = async (
    hostGeoRegion: string,
    pageLoadResult: IWACPageLoadResult
  ) => {
    await pageLoadedHandler(
      hostGeoRegion,
      sessionConfig.wiseEnvironment,
      pageLoadResult,
      documentBootInfo,
      uiHostEventHandlers,
      logger,
      sessionConfig,
      uiHostConfig,
      health,
      sessionId
    );
  };

  // Create list of event handlers and return it
  const handlers: OwletEventHandlers = {
    ...uiHostEventHandlers,
    onRebootDocument: onRebootDocumentHandler,
    onPageLoaded: onPageLoadedHandler,
  };
  return handlers;
}
